import type { Theme } from '@mui/material';

export const styles = {
  catchNullUrl: (theme: Theme) => ({
    margin: 'auto',
    maxWidth: '43.75rem',
    border: `1px solid ${theme.colors.neutral[200]}`,
    borderRadius: '0.5rem',
    textAlign: 'center',
    padding: '3rem',
  }),

  takeMeBackButton: {
    py: 2,
    width: '20rem',
    maxWidth: '100%',
  },
};
